/* unplugin-vue-components disabled */import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  "class": "content"
};
var _hoisted_2 = {
  "class": "list"
};
var _hoisted_3 = ["textContent"];
var _hoisted_4 = ["textContent"];
var _hoisted_5 = ["textContent"];
import { chinaListApi } from '@/api/china';
export default /*@__PURE__*/_defineComponent({
  __name: 'ch2',
  setup: function setup(__props) {
    var chinaData = ref([]);
    onMounted(function () {
      chinaListApi().then(function (res) {
        var _res$data;
        chinaData.value = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : [];
      });
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("li", null, "IIFA中国顾问委员会名单(排名不分先后)", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chinaData), function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.name
        }, [_createElementVNode("p", {
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_3), _createElementVNode("p", {
          textContent: _toDisplayString(item.company)
        }, null, 8, _hoisted_4), _createElementVNode("p", {
          textContent: _toDisplayString(item.post)
        }, null, 8, _hoisted_5)]);
      }), 128))])]);
    };
  }
});